'use client';

import { Tag } from '@chakra-ui/react';
import { useHostname } from '@ae/shared';
import { Environment, getEnvironmentFromHostname } from './utils';

export const EnvironmentTag = () => {
  const hostname = useHostname();
  const environment = getEnvironmentFromHostname(hostname);

  if (environment === Environment.Prod) {
    return null;
  }

  return (
    <Tag id="environmentTag" size="sm" fontWeight="bold" colorScheme="red">
      {environment}
    </Tag>
  );
};
